import { Link, Paper, Typography } from "@mui/material";

import { normalizeWebsiteUrl } from "utils/stringFormatting";

const VendorInformationSection = ({ project }: any) => {
  const url = normalizeWebsiteUrl(project.vendor_id?.website);

  return (
    <Paper sx={{ padding: 2 }}>
      <Typography variant="h3">VENDOR INFORMATION</Typography>
      <Typography component="address">
        {project.vendor_id.name} <br />
        {project.vendor_poc} <br />
        {project.vendor_phone} <br />
        {project.vendor_email} <br />
        {url && (
          <Link href={url} target="_blank" rel="noreferrer">
            {url}
          </Link>
        )}
      </Typography>
    </Paper>
  );
};
export default VendorInformationSection;
